// import 'zone.js';
// import {bootstrapApplication} from '@angular/platform-browser';
// import {provideZoneChangeDetection } from '@angular/core';
// import {GusoHeaderEmployeurConnecteComponent} from 'guso-libangular';
//
// const selector = 'guso-header-employeur-connecte';
// if (document.querySelector(selector)) {
//     bootstrapApplication(GusoHeaderEmployeurConnecteComponent, {providers: [provideZoneChangeDetection()]}).catch(err => console.error('Erreur bootstrap Angular:', err));
// } else {
//     console.debug(`Balise <${selector}> absente : composant non initialisé.`);
// }

import 'zone.js';
import { bootstrapApplication } from '@angular/platform-browser';
import {APP_INITIALIZER, inject, provideZoneChangeDetection} from '@angular/core';
import { provideHttpClient } from '@angular/common/http';
import { GusoHeaderEmployeurConnecteComponent, provideGusoLibraryConfiguration, PreDataGuard} from 'guso-libangular';
import {gusoLibConfig} from '../config/environment';
import {Router} from "@angular/router";

const selector = 'guso-header-employeur-connecte';
if (document.querySelector(selector)) {
    bootstrapApplication(GusoHeaderEmployeurConnecteComponent, {
        providers: [
            provideZoneChangeDetection(),
            provideHttpClient(),
            provideGusoLibraryConfiguration(gusoLibConfig),
            {

                provide: APP_INITIALIZER,

                useFactory: () => () => {

                    const router = inject(Router);

                    const currentUrl = router.url;

                    return PreDataGuard({} as any, { url: currentUrl } as any);

                },

                multi: true,

                deps: [Router]

            }

        ]}).catch(err => console.error('Erreur bootstrap Angular:', err));
} else {
    console.debug(`Balise <${selector}> absente : composant non initialisé.`);
}
